import { Pipe, PipeTransform } from '@angular/core';
import {
  GetOperatorDashboardStatisticsResponse,
  OperatorInfoCard,
} from 'app/models/operator/get-operator-dashboard-statistics';

@Pipe({
  name: 'getChartData',
})
export class GetChartDataPipe implements PipeTransform {
  transform(card: OperatorInfoCard): any {
    const data = {
      labels: card.ChartLabels,
      datasets: [
        {
          data: card.LabelsData,
          fill: true,
          borderCapStyle: 'round',
          tension: 0.4,
          borderColor:
            card.Header === 'Cancellation Rate' ? '#FF0000' : '#165DFF',
          backgroundColor:
            card.Header === 'Cancellation Rate'
              ? '#ff9999'
              : 'rgba(22, 93, 255, 0.2)',
        },
      ],
    };

    return data;
  }
}
